import { Button } from "components";
import { useListFilter } from "../../stores";
import toast from "react-hot-toast";
import { useApi } from "utils";
import { PERMISION } from "security";

export function Delete({
    refecth
} : {
    refecth?: () => void
}) {

    // hooks
    const api = useApi()

    // state
    const {filter} = useListFilter();

    const deleteAction = () => {
        return new Promise<void>((resolve) => {
            toast.promise(
                api.delete(`/employee/delete_data_schedule`, {params: {shift_schedule_id: filter.shift_schedule_id}}),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => {
                        if (err.response.data.detail) {
                            return err.response.data.detail.message
                        }
                        return err.response.data.message
                    }
                }
            ).then(() => {
                refecth && refecth();
            }).catch(() => { }).finally(resolve)
        })

    }

    return (
        <Button
            permission={PERMISION.CARDS.REGISTER.SCHEDULE.DELETE}
            color="primary"
            onClick={deleteAction}
        >
            DELETE
        </Button>
    )
}